// extracted by mini-css-extract-plugin
module.exports = {"container":"GrowYourProjectSectionCards_container__xbxdP"};